export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator) || !import.meta.env.PROD) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => registration.update())
      .then(() => window.dispatchEvent(new CustomEvent("framlage:pwa-status", { detail: { state: "ready" } })))
      .catch(() => window.dispatchEvent(new CustomEvent("framlage:pwa-status", { detail: { state: "error" } })));
  });
}
